import React, { useState, useEffect } from 'react'
import {
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Container,
  Chip,
  useMediaQuery,
  useTheme,
  CircularProgress
} from '@material-ui/core'
import {
  TrendingUp,
  Today,
  CalendarToday,
  DateRange,
  Search,
  AttachMoney,
  ShoppingCart
} from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import ProduitVenduService from '../../services/ProduitVenduService'
import FondService from '../../services/FondService'
import RecolteCat from '../RecolteCat'
import DateTimePicker from '../FormsUI/DateTimePicker'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    minHeight: '100vh',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  title: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
    fontSize: '2.5rem',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  subtitle: {
    color: '#6c757d',
    fontSize: '1.1rem',
  },
  statsContainer: {
    marginBottom: theme.spacing(4),
  },
  searchCard: {
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    background: 'white',
  },
  tableCard: {
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    background: 'white',
  },
  searchButton: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    fontWeight: 600,
    padding: theme.spacing(1.5),
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #1a5a55 0%, #22746d 100%)',
      transform: 'translateY(-2px)',
    },
    transition: 'all 0.3s ease',
  },
  resultChip: {
    fontWeight: 600,
    fontSize: '0.9rem',
    '&.total': {
      background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
      color: 'white',
    },
    '&.amount': {
      background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
      color: 'white',
    },
  },
  infoContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 200,
  },
  dateField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      '&:hover fieldset': {
        borderColor: '#226D68',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#226D68',
        borderWidth: '2px',
      },
    },
  },
}));

const Recolte = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [journee, setJournee] = useState([])
  const [mois, setMois] = useState([])
  const [hier, setHier] = useState([])
  const [annee, setAnne] = useState([])

  const [fondJour, setFondJour] = useState(0)
  const [fondMois, setFondMois] = useState(0)
  const [fondhier, setFondHier] = useState(0)
  const [fondAnnee, setFondAn] = useState(0)

  const [depensesJour, setDepensesJour] = useState(0)
  const [depensesMois, setDepensesMois] = useState(0)
  const [depenseshier, setDepensesHier] = useState(0)
  const [depensesAnnee, setDepensesAnnee] = useState(0)

  const [resultat, setResultat] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchLoading, setSearchLoading] = useState(false)

  const columns = [
    { 
      title: "INTITULE FAMILLE", 
      field: "intituleFam", 
      align: "center", 
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "PRODUIT", 
      field: "nomProd",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "PRIX PRODUIT", 
      field: "prixProdVendu",
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "NOM CLIENT", 
      field: "nom",
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "TELEPHONE CLIENT", 
      field: "telephone",
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "QUANTITE VENDUE", 
      field: "qtVdu",
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "NUMERO FACTURE", 
      field: "numFactSrt",
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "ENREGISTRE", 
      field: "dateInsert", 
      type: "date",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "FORME", 
      field: "FormFarmaceutik",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    { 
      title: "CREATEUR", 
      field: "speudo",
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
    },
  ]

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Récupération des ventes
        const [
          venteJournee,
          venteHier,
          venteMonth,
          venteYear,
          fondJournee,
          fondHier,
          fondMonth,
          fondYear,
          depensesJournee,
          depensesHier,
          depensesMonth,
          depensesYear
        ] = await Promise.all([
          ProduitVenduService.venteJournee(),
          ProduitVenduService.venteHier(),
          ProduitVenduService.venteMonth(),
          ProduitVenduService.venteYear(),
          FondService.fondJournee(),
          FondService.fondHier(),
          FondService.fondMonth(),
          FondService.fondYear(),
          FondService.depensesJournee(),
          FondService.depensesHier(),
          FondService.depensesMonth(),
          FondService.depensesYear()
        ]);

        setJournee(venteJournee.data || []);
        setHier(venteHier.data || []);
        setMois(venteMonth.data || []);
        setAnne(venteYear.data || []);

        setFondJour(fondJournee.data[0]?.val || 0);
        setFondHier(fondHier.data[0]?.val || 0);
        setFondMois(fondMonth.data[0]?.val || 0);
        setFondAn(fondYear.data[0]?.val || 0);

        setDepensesJour(depensesJournee.data[0]?.val || 0);
        setDepensesHier(depensesHier.data[0]?.val || 0);
        setDepensesMois(depensesMonth.data[0]?.val || 0);
        setDepensesAnnee(depensesYear.data[0]?.val || 0);

      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [])

  const initialValues = {
    dateDebut: '',
    dateFin: '',
  }

  const validationSchema = Yup.object().shape({
    dateDebut: Yup.date().required("La date de début est requise"),
    dateFin: Yup.date(),
  })

  const onSubmit = async (values, props) => {
    setSearchLoading(true);
    try {
      const produit = {
        "date1": values.dateDebut,
        "date2": values.dateFin,  
      }
      
      const response = await ProduitVenduService.searchVente(produit);
      setResultat(response.data || []);
    } catch (error) {
      console.error('Erreur lors de la recherche:', error);
    } finally {
      setSearchLoading(false);
    }
  }

  const diffJournee = fondJour + depensesJour
  const diffMois = fondMois + depensesMois
  const diffAnnee = fondAnnee + depensesAnnee
  const diffHier = fondhier + depenseshier

  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
        {/* En-tête */}
        <Box className={classes.header}>
          <Typography variant="h1" className={classes.title}>
            Tableau de Récolte
          </Typography>
          <Typography variant="h6" className={classes.subtitle}>
            Suivi des ventes et analyse des performances
          </Typography>
        </Box>

        {/* Cartes de statistiques avec le nouveau design RecolteCat */}
        <Grid container spacing={3} className={classes.statsContainer}>
          <Grid item xs={12} sm={6} md={3}>
            <RecolteCat 
              title="Aujourd'hui" 
              data={journee} 
              type={diffJournee}
              icon={<Today />}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <RecolteCat 
              title="Hier" 
              data={hier} 
              type={diffHier}
              icon={<CalendarToday />}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <RecolteCat 
              title="Mois en cours" 
              data={mois} 
              type={diffMois}
              icon={<DateRange />}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <RecolteCat 
              title="Année en cours" 
              data={annee} 
              type={diffAnnee}
              icon={<TrendingUp />}
              loading={loading}
            />
          </Grid>
        </Grid>

        {/* Formulaire de recherche */}
        <Card className={classes.searchCard}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={2}>
              <Search style={{ marginRight: 8, color: '#226D68' }} />
              <Typography variant="h5" style={{ color: '#226D68', fontWeight: 600 }}>
                Recherche Avancée
              </Typography>
            </Box>
            
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
              {(props) => (
                <Form noValidate>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={5}>
                      <DateTimePicker
                        name="dateDebut"
                        label="Date de début"
                        className={classes.dateField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <DateTimePicker
                        name="dateFin"
                        label="Date de fin"
                        className={classes.dateField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Button 
                        type='submit' 
                        className={classes.searchButton}
                        variant='contained' 
                        fullWidth
                        disabled={searchLoading}
                        startIcon={searchLoading ? <CircularProgress size={20} /> : <Search />}
                      >
                        {searchLoading ? 'Recherche...' : 'Rechercher'}
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </CardContent>
        </Card>

        {/* Résultats de recherche */}
        {resultat.length > 0 && (
          <Card className={classes.tableCard}>
            <CardContent style={{ padding: 0 }}>
              <Box className={classes.infoContainer} p={2}>
                <Chip
                  icon={<ShoppingCart />}
                  label={`Total: ${resultat.length} ventes`}
                  className={`${classes.resultChip} total`}
                />
                <Chip
                  icon={<AttachMoney />}
                  label={`Montant: ${resultat.reduce((a, v) => a + (v.total || 0), 0).toLocaleString()} Fcfa`}
                  className={`${classes.resultChip} amount`}
                />
              </Box>
              
              <MaterialTable 
                columns={columns} 
                data={resultat}  
                options={{
                  sorting: true, 
                  search: true,
                  searchFieldAlignment: "right", 
                  searchAutoFocus: true, 
                  searchFieldVariant: "outlined",
                  filtering: true, 
                  paging: true, 
                  pageSizeOptions: [5, 10, 20, 50, 100], 
                  pageSize: 10,
                  paginationType: "stepped", 
                  showFirstLastPageButtons: true, 
                  paginationPosition: "bottom", 
                  exportButton: true,
                  exportAllData: true, 
                  exportFileName: "Produits_Vendus_Data", 
                  addRowPosition: "first", 
                  actionsColumnIndex: -1, 
                  selection: false,
                  showSelectAllCheckbox: false, 
                  showTextRowsSelected: false,
                  columnsButton: true,
                  rowStyle: (data, index) => index % 2 === 0 ? { background: "#f8f9fa" } : null,
                  headerStyle: { 
                    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                    color: "#fff",
                    fontSize: '14px',
                    fontWeight: 600,
                  },
                }}
                title={
                  <Typography variant="h6" style={{ color: '#226D68', fontWeight: 600 }}>
                    Liste des Produits Vendus
                  </Typography>
                }
                icons={{ Add: () => <AddIcon /> }}
              />
            </CardContent>
          </Card>
        )}

        {/* Message quand aucun résultat */}
        {resultat.length === 0 && !searchLoading && (
          <Card className={classes.tableCard}>
            <CardContent>
              <Box textAlign="center" py={4}>
                <Search style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }} />
                <Typography variant="h6" color="textSecondary" gutterBottom>
                  Aucune donnée trouvée
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Utilisez le formulaire de recherche pour afficher les résultats
                </Typography>
              </Box>
            </CardContent>
          </Card>
        )}
      </Container>
    </div>
  )
}

export default Recolte